<template>
  <feature name="apps">
    <Divider
      v-if="isDeviceRoute && isMobile"
      layout="vertical"
    />

    <button
      ref="appsBtnRef"
      v-tooltip.bottom="{ value: $t('common.apps_services'), disabled: isMobile }"
      type="button"
      class="inline-flex items-center justify-center w-10 h-10 rounded-full border-none bg-transparent text-[#2b3035] cursor-pointer transition-colors duration-150 hover:bg-[#f2f5f8] focus-visible:bg-[#f2f5f8] focus-visible:outline-none"
      aria-label="Apps & Services"
      @click="toggleApps"
    >
      <i
        class="pi pi-th-large"
        style="font-size: 1.25rem;"
      />
    </button>

    <Popover ref="appsPopoverRef">
      <ProductNavLinkComponent @select="onAppSelect" />
    </Popover>
  </feature>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import Popover from 'primevue/popover';
import Divider from 'primevue/divider';
import Tooltip from 'primevue/tooltip';
import Feature from 'vue-feature-toggle';
import ProductNavLinkComponent from '@/components/shared/ProductNavLinkComponent.vue';

export default defineComponent({
  name: 'AppsMenuButton',
  components: { Popover, Divider, Feature, ProductNavLinkComponent },
  directives: {
    tooltip: Tooltip,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    isDeviceRoute: {
      type: Boolean,
      default: false,
    },
  },
  // emitted before the popover opens so the parent can close the profile menu
  emits: ['open'],
  setup(_props, { emit }) {
    const appsPopoverRef = ref();
    const appsBtnRef = ref<HTMLElement | null>(null);

    const toggleApps = (event: MouseEvent) => {
      emit('open');
      appsPopoverRef.value?.toggle(event);
    };
    const onAppSelect = () => { appsPopoverRef.value?.hide(); };

    return { appsPopoverRef, appsBtnRef, toggleApps, onAppSelect };
  },
});
</script>
